module.exports = __webpack_public_path__ + "img/sqsfjd.0378de4a.png";